<template>
  <Modal class="input-modal" v-if="modals.input" @close="closeModal">
    <h3>{{ title }}</h3>

    <div class="input-group">
      <label>{{ label }}</label>
      <input
        type="text"
        v-model="inputValue"
        :placeholder="placeholder"
        :maxlength="maxlength"
        @keyup.enter="save"
        ref="inputField"
      />
    </div>

    <div class="button-group">
      <div class="button save" @click="save">
        {{ $t("common.confirm") }}
      </div>
      <div class="button cancel" @click="closeModal">
        {{ $t("common.cancel") }}
      </div>
    </div>
  </Modal>
</template>

<script>
import Modal from "./Modal";
import { mapState } from "vuex";

export default {
  components: {
    Modal,
  },
  computed: {
    ...mapState(["modals"]),
    title() {
      return this.modals.inputData?.title || "";
    },
    label() {
      return this.modals.inputData?.label || "";
    },
    placeholder() {
      return this.modals.inputData?.placeholder || "";
    },
    maxlength() {
      return this.modals.inputData?.maxlength || 50;
    },
  },
  data() {
    return {
      inputValue: "",
    };
  },
  watch: {
    "modals.input"(isOpen) {
      if (isOpen) {
        // Load initial value when modal opens
        this.inputValue = this.modals.inputData?.initialValue || "";
        // Focus input after modal renders
        this.$nextTick(() => {
          if (this.$refs.inputField) {
            this.$refs.inputField.focus();
            this.$refs.inputField.select();
          }
        });
      }
    },
  },
  methods: {
    save() {
      const value = this.inputValue.trim();
      if (this.modals.inputData?.onConfirm) {
        this.modals.inputData.onConfirm(value);
      }
      this.closeModal();
    },
    closeModal() {
      this.$store.commit("toggleModal", "input");
    },
  },
};
</script>

<style scoped lang="scss">
@import "../../vars.scss";

.input-modal {
  ::v-deep .top-right-buttons {
    display: none !important;
  }

  h3 {
    display: none !important;
  }

  .input-group {
    margin-bottom: 15px;

    label {
      display: block;
      margin-bottom: 10px;
      font-size: 17px;
      font-weight: 500;
      color: rgba(255, 255, 255, 0.95);
      text-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);
      letter-spacing: 0.3px;
    }

    input {
      width: 100%;
      padding: 14px 18px;
      font-size: 16px;
      border: 2px solid transparent;
      border-radius: 12px;
      background: rgba(255, 255, 255, 0.98);
      color: #2c3e50;
      box-sizing: border-box;
      transition: all 0.3s ease;
      font-weight: 500;

      &:focus {
        outline: none;
        background: white;
        border-color: #4a90e2;
        box-shadow: 0 0 0 4px rgba(74, 144, 226, 0.15),
                    0 4px 12px rgba(0, 0, 0, 0.1);
        transform: translateY(-1px);
      }

      &::placeholder {
        color: #95a5a6;
        font-weight: 400;
      }
    }
  }

  .button-group {
    display: flex;
    gap: 8px;
    margin-top: 12px;
    justify-content: flex-end;

    .button {
      padding: 6px 16px;
      border-radius: 20px;
      font-size: 13px;
      font-weight: 500;
      text-align: center;
      cursor: pointer;
      transition: all 0.2s ease;
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
      border: none;

      &.save {
        background: #007bff;
        color: white;

        &:hover {
          background: #0069d9;
          box-shadow: 0 3px 6px rgba(0, 123, 255, 0.25);
        }

        &:active {
          background: #0056b3;
          transform: scale(0.98);
        }
      }

      &.cancel {
        background: #dc3545;
        color: white;

        &:hover {
          background: #c82333;
          box-shadow: 0 3px 6px rgba(220, 53, 69, 0.25);
        }

        &:active {
          background: #bd2130;
          transform: scale(0.98);
        }
      }
    }
  }
}
</style>
